/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

const Bio = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      avatar: file(absolutePath: { regex: "/profile-pic.jpg/" }) {
        childImageSharp {
          fixed(width: 50, height: 50) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      site {
        siteMetadata {
          author {
            name
            summary
          }
          social {
            twitter
          }
        }
      }
    }
  `)

  const { author, social } = data.site.siteMetadata
  return (
    <div className="flex space-x-2">
      <div>
        <Image
          fixed={data.avatar.childImageSharp.fixed}
          alt={author.name}
          className="block"
          style={{
            marginBottom: 0,
            minWidth: 50,
            borderRadius: `100%`,
          }}
          imgStyle={{
            borderRadius: `50%`,
          }}
        />
      </div>
      <div>
        <p className="px-4">
          Written by <strong>Royi Hagigi</strong>, front-end engineer @ Facebook
          building the new{" "}
          <a href="https://www.facebook.com" className="text-blue-600 hover:underline">
            Facebook.com
          </a>{" "}
          from the ground up with React & Relay!
          {` `}
          <a
            className="text-blue-600 hover:underline"
            href={`https://twitter.com/${social.twitter}`}
          >
            Follow @rhagigi on Twitter.
          </a>
        </p>
      </div>
    </div>
  )
}

export default Bio
